<template>
  <AppHeader />

  <div class="login-container">
    <!-- 简洁背景装饰 -->
    <div class="bg-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
    </div>

    <!-- 登录卡片 -->
    <div class="login-card">
      <!-- 左侧品牌区域 -->
      <div class="brand-section">
        <div class="brand-content">
          <div class="logo">
            <div class="logo-icon">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                <rect width="40" height="40" rx="8" fill="#2B7AF6"/>
                <path d="M12 20L17 25L28 14" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="logo-text">
              <span class="brand-name">IoT 物联</span>
              <span class="brand-sub">青帧智维科技</span>
            </div>
          </div>

          <div class="brand-message">
            <h1 class="brand-title">{{ isLoginMode ? '欢迎登录' : '注册账号' }}</h1>
            <p class="brand-desc">{{ isLoginMode ? '登录物联网平台，管理您的设备与数据' : '加入物联网平台，开启智能管理' }}</p>
          </div>

          <div class="brand-features">
            <div class="feature-item">
              <span class="feature-dot"></span>
              <span class="feature-text">设备实时监控</span>
            </div>
            <div class="feature-item">
              <span class="feature-dot"></span>
              <span class="feature-text">数据安全加密</span>
            </div>
            <div class="feature-item">
              <span class="feature-dot"></span>
              <span class="feature-text">多终端管理</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧表单区域 -->
      <div class="form-section">
        <div class="form-content">
          <!-- 登录/注册切换 -->
          <!-- <div class="mode-tabs">
            <button 
              class="mode-tab" 
              :class="{ active: isLoginMode }"
              @click="switchMode('login')"
            >
              登录
            </button>
            <button 
              class="mode-tab" 
              :class="{ active: !isLoginMode }"
              @click="switchMode('register')"
            >
              注册
            </button>
          </div> -->

          <h2 class="form-title">{{ isLoginMode ? '账户登录' : '创建账户' }}</h2>
          <p class="form-subtitle">{{ isLoginMode ? '选择您的身份角色' : '填写信息完成注册' }}</p>

          <!-- ========== 登录模式 ========== -->
          <template v-if="isLoginMode">
            <!-- 身份选择 -->
            <div class="role-select">
              <div class="role-options">
                <div 
                  class="role-option"
                  :class="{ active: userType === 'user' }"
                  @click="userType = 'user'"
                >
                  <span class="role-icon">👤</span>
                  <span class="role-name">用户</span>
                </div>
                <div 
                  class="role-option"
                  :class="{ active: userType === 'admin' }"
                  @click="userType = 'admin'"
                >
                  <span class="role-icon">🛡️</span>
                  <span class="role-name">管理员</span>
                </div>
              </div>
            </div>

            <form @submit.prevent="handleLogin" class="login-form">
              <div class="form-group">
                <label>用户名</label>
                <div class="input-wrapper">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
                  </svg>
                  <input 
                    v-model="loginForm.username" 
                    type="text" 
                    placeholder="请输入用户名"
                    required
                    :disabled="loading"
                  />
                </div>
              </div>

              <div class="form-group">
                <label>密码</label>
                <div class="input-wrapper">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                  </svg>
                  <input 
                    v-model="loginForm.password" 
                    type="password"
                    placeholder="请输入密码"
                    required
                    :disabled="loading"
                  />
                </div>
              </div>

              <div class="form-options">
                <label class="remember-me">
                  <input type="checkbox" v-model="rememberMe" :disabled="loading" />
                  <span>记住我</span>
                </label>
                <a href="#" class="forgot-link">忘记密码？</a>
              </div>

              <button type="submit" class="login-btn" :disabled="loading">
                <span v-if="!loading">登 录</span>
                <span v-else class="loading-text">
                  <span class="spinner"></span>
                  登录中...
                </span>
              </button>
            </form>

            <div class="switch-link">
              还没有账号？<a href="#" @click.prevent="switchMode('register')">立即注册</a>
            </div>
          </template>

          <!-- ========== 注册模式 ========== -->
          <template v-else>
            <form @submit.prevent="handleRegister" class="login-form">
              <div class="form-group">
                <label>用户名 <span class="required">*</span></label>
                <div class="input-wrapper">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
                  </svg>
                  <input 
                    v-model="registerForm.username" 
                    type="text" 
                    placeholder="请输入用户名"
                    required
                    :disabled="loading"
                  />
                </div>
              </div>

              <div class="form-group">
                <label>昵称 <span class="required">*</span></label>
                <div class="input-wrapper">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
                  </svg>
                  <input 
                    v-model="registerForm.nickname" 
                    type="text" 
                    placeholder="请输入昵称"
                    required
                    :disabled="loading"
                  />
                </div>
              </div>

              <div class="form-group">
                <label>密码 <span class="required">*</span></label>
                <div class="input-wrapper">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                  </svg>
                  <input 
                    v-model="registerForm.password" 
                    type="password"
                    placeholder="至少6位"
                    required
                    :disabled="loading"
                    minlength="6"
                  />
                </div>
              </div>

              <div class="form-group">
                <label>确认密码 <span class="required">*</span></label>
                <div class="input-wrapper">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                  </svg>
                  <input 
                    v-model="registerForm.confirmPassword" 
                    type="password"
                    placeholder="再次输入密码"
                    required
                    :disabled="loading"
                  />
                </div>
              </div>

              <div class="form-group">
                <label>邮箱</label>
                <div class="input-wrapper">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                  <input 
                    v-model="registerForm.email" 
                    type="email" 
                    placeholder="选填"
                    :disabled="loading"
                  />
                </div>
              </div>

              <div class="form-group">
                <label>手机号</label>
                <div class="input-wrapper">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>
                    <line x1="12" y1="18" x2="12.01" y2="18"/>
                  </svg>
                  <input 
                    v-model="registerForm.phone" 
                    type="tel" 
                    placeholder="选填"
                    :disabled="loading"
                  />
                </div>
              </div>

              <div class="form-group">
                <label>单位名称 <span class="required">*</span></label>
                <div class="input-wrapper">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                    <polyline points="9 22 9 12 15 12 15 22"/>
                  </svg>
                  <input 
                    v-model="registerForm.company" 
                    type="text" 
                    placeholder="请输入单位名称"
                    required
                    :disabled="loading"
                  />
                </div>
              </div>

              <div class="form-group">
                <label>注册码 <span class="optional-tip">选填</span></label>
                <div class="input-wrapper">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                  </svg>
                  <input 
                    v-model="registerForm.registerCode" 
                    type="text" 
                    placeholder="填写注册码可获后台管理权限，留空为普通用户"
                    :disabled="loading"
                  />
                </div>
                <p class="field-hint">有注册码 → 管理员（可进后台）；留空 → 普通用户</p>
              </div>

              <button type="submit" class="login-btn" :disabled="loading">
                <span v-if="!loading">注 册</span>
                <span v-else class="loading-text">
                  <span class="spinner"></span>
                  注册中...
                </span>
              </button>

              <div class="switch-link">
                已有账号？<a href="#" @click.prevent="switchMode('login')">立即登录</a>
              </div>
            </form>
          </template>
        </div>
      </div>
    </div>

    <!-- 提示弹窗 -->
    <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
      <div class="modal-container" :class="modalType">
        <div class="modal-icon">{{ modalIcon }}</div>
        <h3 class="modal-title">{{ modalTitle }}</h3>
        <p class="modal-message">{{ modalMessage }}</p>
        <button class="modal-btn" @click="closeModal">{{ modalBtnText }}</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { login, register } from '@/api/auth'
import AppHeader from '@/components/AppHeader.vue'  // 引入导航栏组件
const router = useRouter()
const userStore = useUserStore()

const isLoginMode = ref(true)

const loginForm = reactive({
  username: '',
  password: ''
})

const registerForm = reactive({
  username: '',
  nickname: '',
  password: '',
  confirmPassword: '',
  email: '',
  phone: '',
  company: '',
  registerCode: ''
})

const userType = ref('user')
const rememberMe = ref(false)
const loading = ref(false)

const showModal = ref(false)
const modalType = ref('error')
const modalTitle = ref('')
const modalMessage = ref('')
const modalIcon = ref('')
const modalBtnText = ref('我知道了')

const ERROR_MESSAGES = {
  400: '请求参数错误，请检查输入',
  401: '认证失败，请重新登录',
  403: '您没有权限执行此操作',
  404: '用户不存在，请检查用户名',
  409: '用户名、邮箱或手机号已被注册',
  500: '服务器内部错误，请稍后重试',
  503: '服务暂时不可用，请稍后重试',
  'AUTH_001': '用户名或密码错误',
  'AUTH_002': '账号已被锁定，请联系管理员',
  'AUTH_003': '账号已过期，请联系管理员',
  'AUTH_004': '密码已过期，请重置密码',
  'AUTH_005': '账号已被禁用，请联系管理员',
  'PERM_001': '您没有权限执行此操作',
  'PERM_002': '身份验证失败，请重新登录',
  'SYS_001': '认证服务异常，请稍后重试'
}

const switchMode = (mode) => {
  if (loading.value) return
  isLoginMode.value = mode === 'login'
}

const showModalDialog = (options) => {
  const {
    type = 'error',
    title = '提示',
    message = '',
    icon = '',
    btnText = '我知道了'
  } = options

  const iconMap = {
    error: '❌',
    warning: '⚠️',
    success: '✅',
    info: 'ℹ️'
  }

  modalType.value = type
  modalTitle.value = title
  modalMessage.value = message
  modalIcon.value = icon || iconMap[type] || 'ℹ️'
  modalBtnText.value = btnText
  showModal.value = true
}

const closeModal = () => {
  showModal.value = false
}

const getErrorMessage = (error) => {
  const response = error.response
  if (response) {
    const status = response.status
    const data = response.data
    if (data?.message) return data.message
    if (ERROR_MESSAGES[status]) return ERROR_MESSAGES[status]
  }
  if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
    return '请求超时，请检查网络连接'
  }
  if (error.message?.includes('Network Error')) {
    return '网络连接失败，请检查网络设置'
  }
  return error.message || '操作失败，请重试'
}

const validatePhone = (phone) => {
  if (!phone) return true
  return /^1[3-9]\d{9}$/.test(phone)
}

const validateEmail = (email) => {
  if (!email) return true
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)
}

const handleLogin = async () => {
  if (!loginForm.username.trim()) {
    showModalDialog({
      type: 'warning',
      title: '提示',
      message: '请输入用户名',
      btnText: '我知道了'
    })
    return
  }
  if (!loginForm.password.trim()) {
    showModalDialog({
      type: 'warning',
      title: '提示',
      message: '请输入密码',
      btnText: '我知道了'
    })
    return
  }

  loading.value = true

  try {
    const response = await login({
      username: loginForm.username.trim(),
      password: loginForm.password.trim()
    })

    // 后端返回格式：{ code, message, data: { user, token } }
    const { data } = response
    const { user, token } = data

    // 验证身份是否匹配
    const isAdmin = user.isAdmin || false
    
    if (userType.value === 'admin' && !isAdmin) {
      showModalDialog({
        type: 'warning',
        title: '身份不匹配',
        message: '该账号不是管理员账号，请切换为「操作员」身份登录',
        btnText: '我知道了'
      })
      loading.value = false
      return
    }
    
    if (userType.value === 'user' && isAdmin) {
      showModalDialog({
        type: 'warning',
        title: '身份不匹配',
        message: '该账号是管理员账号，请切换为「管理员」身份登录',
        btnText: '我知道了'
      })
      loading.value = false
      return
    }

    // 存储认证信息 - 使用新的 setAuth 方法
    userStore.setAuth({ token, user })

    // 根据角色跳转
    const targetPath = isAdmin ? '/admin/dashboard' : '/user/dashboard'
    router.push(targetPath)

  } catch (error) {
    console.error('登录失败:', error)
    const errorMsg = getErrorMessage(error)
    showModalDialog({
      type: 'error',
      title: '登录失败',
      message: errorMsg,
      btnText: '重新尝试'
    })
  } finally {
    loading.value = false
  }
}

const handleRegister = async () => {
  if (!registerForm.username.trim()) {
    showModalDialog({
      type: 'warning',
      title: '提示',
      message: '请输入用户名',
      btnText: '我知道了'
    })
    return
  }

  if (registerForm.username.length < 3) {
    showModalDialog({
      type: 'warning',
      title: '提示',
      message: '用户名长度不能少于3个字符',
      btnText: '我知道了'
    })
    return
  }

  if (!registerForm.nickname.trim()) {
    showModalDialog({
      type: 'warning',
      title: '提示',
      message: '请输入昵称',
      btnText: '我知道了'
    })
    return
  }

  if (!registerForm.password.trim()) {
    showModalDialog({
      type: 'warning',
      title: '提示',
      message: '请输入密码',
      btnText: '我知道了'
    })
    return
  }

  if (registerForm.password.length < 6) {
    showModalDialog({
      type: 'warning',
      title: '提示',
      message: '密码长度不能少于6个字符',
      btnText: '我知道了'
    })
    return
  }

  if (registerForm.password !== registerForm.confirmPassword) {
    showModalDialog({
      type: 'warning',
      title: '提示',
      message: '两次输入的密码不一致，请重新输入',
      btnText: '我知道了'
    })
    return
  }

  if (!registerForm.company.trim()) {
    showModalDialog({
      type: 'warning',
      title: '提示',
      message: '请输入单位名称',
      btnText: '我知道了'
    })
    return
  }

  if (registerForm.email && !validateEmail(registerForm.email)) {
    showModalDialog({
      type: 'warning',
      title: '提示',
      message: '请输入正确的邮箱格式',
      btnText: '我知道了'
    })
    return
  }

  if (registerForm.phone && !validatePhone(registerForm.phone)) {
    showModalDialog({
      type: 'warning',
      title: '提示',
      message: '请输入正确的手机号格式',
      btnText: '我知道了'
    })
    return
  }

  loading.value = true

  try {
    const registerData = {
      username: registerForm.username.trim(),
      nickname: registerForm.nickname.trim(),
      password: registerForm.password.trim(),
      email: registerForm.email.trim() || null,
      phone: registerForm.phone.trim() || null,
      company: registerForm.company.trim(),
      registerCode: registerForm.registerCode.trim() || null
    }

    const response = await register(registerData)
    const data = response.data || response
    const becameAdmin = !!registerData.registerCode

    showModalDialog({
      type: 'success',
      title: '注册成功',
      message: becameAdmin
        ? '🎉 注册成功！您已获得后台管理权限，请返回登录（身份选「管理员」）'
        : '🎉 账号注册成功！请返回登录',
      btnText: '去登录'
    })

    setTimeout(() => {
      Object.keys(registerForm).forEach(key => {
        registerForm[key] = ''
      })
      switchMode('login')
    }, 2000)

  } catch (error) {
    console.error('注册失败:', error)
    const errorMsg = getErrorMessage(error)
    showModalDialog({
      type: 'error',
      title: '注册失败',
      message: errorMsg || '注册失败，请稍后重试',
      btnText: '重新尝试'
    })
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f4f8;
  padding: 20px;
  position: relative;
  overflow: hidden;
}

/* ===== 背景装饰 ===== */
.bg-shapes {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
}

.shape {
  position: absolute;
  border-radius: 50%;
}

.shape-1 {
  width: 600px;
  height: 600px;
  top: -200px;
  right: -150px;
  background: radial-gradient(circle, rgba(43, 122, 246, 0.06) 0%, transparent 70%);
}

.shape-2 {
  width: 400px;
  height: 400px;
  bottom: -100px;
  left: -100px;
  background: radial-gradient(circle, rgba(43, 122, 246, 0.04) 0%, transparent 70%);
}

.shape-3 {
  width: 200px;
  height: 200px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: radial-gradient(circle, rgba(43, 122, 246, 0.03) 0%, transparent 70%);
}

/* ===== 登录卡片 ===== */
.login-card {
  display: flex;
  width: 100%;
  max-width: 960px;
  min-height: 560px;
  background: #ffffff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
  position: relative;
  z-index: 10;
}

/* ===== 品牌区域 ===== */
.brand-section {
  flex: 1;
  background: #2B7AF6;
  padding: 48px 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
}

.brand-section::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -30%;
  width: 80%;
  height: 80%;
  background: radial-gradient(ellipse, rgba(255, 255, 255, 0.06) 0%, transparent 70%);
  pointer-events: none;
}

.brand-section::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
}

.brand-content {
  position: relative;
  z-index: 1;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/* Logo */
.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 48px;
}

.logo-icon {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-text {
  display: flex;
  flex-direction: column;
}

.brand-name {
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 0.5px;
}

.brand-sub {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
  letter-spacing: 2px;
  text-transform: uppercase;
  font-weight: 400;
}

/* Brand Message */
.brand-message {
  margin-bottom: 32px;
}

.brand-title {
  font-size: 32px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 8px;
  letter-spacing: -0.3px;
}

.brand-desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.6;
  font-weight: 300;
}

/* Features */
.brand-features {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.feature-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  flex-shrink: 0;
}

.feature-text {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  font-weight: 300;
}

/* ===== 表单区域 ===== */
.form-section {
  flex: 1;
  padding: 48px 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
}

.form-content {
  width: 100%;
  max-width: 360px;
}

/* ===== 模式切换 ===== */
.mode-tabs {
  display: flex;
  background: #f0f4f8;
  border-radius: 10px;
  padding: 3px;
  margin-bottom: 24px;
}

.mode-tab {
  flex: 1;
  padding: 8px 16px;
  border: none;
  background: transparent;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #8c9aa8;
  cursor: pointer;
  transition: all 0.3s ease;
}

.mode-tab.active {
  background: #ffffff;
  color: #2B7AF6;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.mode-tab:hover:not(.active) {
  color: #4a5a6a;
}

/* ===== 表单标题 ===== */
.form-title {
  font-size: 24px;
  font-weight: 700;
  color: #1a2634;
  margin-bottom: 4px;
  letter-spacing: -0.2px;
}

.form-subtitle {
  color: #8c9aa8;
  font-size: 14px;
  margin-bottom: 24px;
}

.required {
  color: #e74c5e;
  font-weight: 700;
  margin-left: 2px;
}

/* ===== 身份选择 ===== */
.role-select {
  margin-bottom: 20px;
}

.role-options {
  display: flex;
  gap: 10px;
}

.role-option {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  border: 2px solid #e8edf2;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fafbfc;
}

.role-option:hover {
  border-color: #c8d4e0;
}

.role-option.active {
  border-color: #2B7AF6;
  background: rgba(43, 122, 246, 0.04);
}

.role-option .role-icon {
  font-size: 16px;
}

.role-option .role-name {
  font-size: 14px;
  font-weight: 500;
  color: #1a2634;
}

.role-option.active .role-name {
  color: #2B7AF6;
}

/* ===== 表单 ===== */
.login-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.form-group label {
  font-size: 13px;
  font-weight: 500;
  color: #4a5a6a;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-wrapper svg {
  position: absolute;
  left: 14px;
  color: #b0c0d0;
  pointer-events: none;
}

.input-wrapper input {
  width: 100%;
  padding: 11px 14px 11px 42px;
  border: 2px solid #e8edf2;
  border-radius: 10px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: #fafbfc;
  color: #1a2634;
  font-weight: 400;
}

.input-wrapper input::placeholder {
  color: #b0c0d0;
}

.optional-tip {
  font-size: 12px;
  font-weight: 400;
  color: #9aa7b4;
}

.field-hint {
  font-size: 12px;
  color: #9aa7b4;
  margin-top: 6px;
  line-height: 1.4;
}

.input-wrapper input:focus {
  outline: none;
  border-color: #2B7AF6;
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(43, 122, 246, 0.06);
}

.input-wrapper input:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2px;
}

.remember-me {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #8c9aa8;
  cursor: pointer;
}

.remember-me input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #2B7AF6;
  cursor: pointer;
}

.remember-me input[type="checkbox"]:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.forgot-link {
  font-size: 13px;
  color: #2B7AF6;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}

.forgot-link:hover {
  color: #1a5fc7;
}

/* ===== 登录按钮 ===== */
.login-btn {
  width: 100%;
  padding: 12px;
  background: #2B7AF6;
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.3s ease;
  margin-top: 4px;
}

.login-btn:hover:not(:disabled) {
  background: #1a6ae0;
  box-shadow: 0 4px 16px rgba(43, 122, 246, 0.3);
  transform: translateY(-1px);
}

.login-btn:active:not(:disabled) {
  transform: translateY(0);
}

.login-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
}

.loading-text {
  display: flex;
  align-items: center;
  gap: 8px;
}

.spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.25);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.switch-link {
  text-align: center;
  font-size: 13px;
  color: #8c9aa8;
  margin-top: 16px;
}

.switch-link a {
  color: #2B7AF6;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}

.switch-link a:hover {
  color: #1a5fc7;
}

/* ===== 弹窗 ===== */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.25s ease;
}

.modal-container {
  background: #ffffff;
  padding: 36px 32px 32px;
  border-radius: 16px;
  max-width: 380px;
  width: 90%;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  animation: slideUp 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.modal-icon {
  font-size: 48px;
  display: block;
  margin-bottom: 12px;
}

.modal-title {
  font-size: 20px;
  font-weight: 700;
  color: #1a2634;
  margin-bottom: 8px;
}

.modal-message {
  font-size: 14px;
  color: #6a7a8a;
  line-height: 1.6;
  margin-bottom: 24px;
}

.modal-btn {
  padding: 10px 40px;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #ffffff;
  background: #2B7AF6;
}

.modal-btn:hover {
  background: #1a6ae0;
  box-shadow: 0 4px 16px rgba(43, 122, 246, 0.25);
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* ===== 响应式 ===== */
@media (max-width: 820px) {
  .login-card {
    flex-direction: column;
    min-height: auto;
    border-radius: 16px;
    max-width: 440px;
  }

  .brand-section {
    padding: 32px 28px;
    min-height: 200px;
  }

  .brand-title {
    font-size: 26px;
  }

  .brand-message {
    margin-bottom: 20px;
  }

  .brand-features {
    flex-direction: row;
    gap: 20px;
  }

  .form-section {
    padding: 32px 24px;
    max-height: none;
  }

  .form-content {
    max-width: 100%;
  }
}

@media (max-width: 480px) {
  .login-card {
    border-radius: 12px;
  }

  .brand-section {
    padding: 24px 20px;
    min-height: 160px;
  }

  .brand-title {
    font-size: 22px;
  }

  .brand-name {
    font-size: 18px;
  }

  .brand-features {
    flex-direction: column;
    gap: 6px;
  }

  .form-section {
    padding: 24px 16px;
  }

  .form-title {
    font-size: 20px;
  }

  .role-option {
    padding: 8px 12px;
    font-size: 13px;
  }

  .input-wrapper input {
    padding: 10px 12px 10px 38px;
    font-size: 13px;
  }

  .login-btn {
    padding: 11px;
    font-size: 14px;
  }

  .modal-container {
    padding: 28px 20px 24px;
  }
}
</style>